import { MAKE_LOAN_PAYMENT_LOAD } from "./types"

export const makeLoanPaymentLoad = () => {
  return {
    type: MAKE_LOAN_PAYMENT_LOAD
  }
}